import * as React from 'react';
import useLiveOrderDetails from '../../hooks/liveOrders/useLiveOrderDetails';
import { LiveOrdersData } from '../../models/LiveOrders';
import LiveOrderProducts from './LiveOrderProducts';
import { StyledDialogContent } from '../styled/Dialog/StyledDialogContent';
import { InvoiceDetailsDialogTitle } from '../shared/Typography/InvoiceDetailsDialogTitle';
import { useTranslation } from 'react-i18next';
import { LiveOrdersDetailsWrapper } from './LiveOrdersDetailsWrapper';

export const LiveOrderDetails: React.FC<{ liveOrder: LiveOrdersData }> = (
    props
) => {
    const { liveOrder } = props;

    if (!liveOrder) {
        return <></>;
    }

    const { order, isLoading, isError } = useLiveOrderDetails(
        liveOrder.orderID
    );
    const { t } = useTranslation('liveOrders', {
        keyPrefix: 'LIVE_ORDER_DETAILS',
    });

    return (
        <>
            <StyledDialogContent>
                <InvoiceDetailsDialogTitle>
                    {t('DETAILS_TITLE')}
                </InvoiceDetailsDialogTitle>
                <LiveOrdersDetailsWrapper liveOrder={liveOrder} />
                <LiveOrderProducts
                    products={order}
                    isLoading={isLoading}
                    isError={isError}
                />
            </StyledDialogContent>
        </>
    );
};
